import "@/rasa.css";
import "@/rj-extra.css";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Shell from "@/components/Shell";

function Gate() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#044f31", color: "#fff" }}>
        <div data-testid="app-loading" style={{ textAlign: "center" }}>
          <div className="brand-logo-frame" style={{ margin: "0 auto 14px" }}>
            <img src="/rasa-juara-logo-v3.webp?v=3" alt="Rasa Juara" className="brand-logo-image" />
          </div>
          <p style={{ letterSpacing: "0.2em", fontWeight: 800, fontSize: 12 }}>MEMUAT SALES HUB…</p>
        </div>
      </div>
    );
  }
  return user ? <Shell /> : <Login />;
}

export default function App() {
  return (
    <AuthProvider>
      <Gate />
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}
